import { render, staticRenderFns } from "./Rejected.vue?vue&type=template&id=370d814a&"
import script from "./Rejected.vue?vue&type=script&lang=js&"
export * from "./Rejected.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports